import { createReducer } from 'redux-starter-kit';
import { fetchAuthenticateUser, acceptTermsAndConditions, setCurrentLoginAddress } from './loginUiActions';
import { selectRequest } from '../../domain/requests/RequestReducer';

/**
 * A selector for the current authentication request.
 * @param {object} state The redux state for the application.
 */
export const selectAuthenticationRequest = (state) => {
  const requestId = state.via.ui.login.fetchAuthenticateUserRequestId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

/**
 * A selector for the current accept terms and conditions request
 * @param {object} state The redux state for the application.
 */
export const selectAcceptTermsRequest = (state) => {
  const requestId = state.via.ui.login.acceptTermsAndConditionsId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

/**
 * A selector for the current login address as typed on the login screen.
 * @param {object} state The redux state for the application.
 */
export const selectCurrentLoginAddress = (state) => {
  const emailAddress = state.via.ui.login.currentLoginAddress;
  if (!emailAddress) return null;

  return emailAddress;
};

const initialLoginState = {
  fetchAuthenticateUserRequestId: null, // The request id of the auth call.
  acceptTermsAndConditionsId: null,
  currentLoginAddress: '',
};

/**
 * A reducer for the login component in the UI.
 */
const loginReducer = createReducer(initialLoginState, {
  [fetchAuthenticateUser]: (state, action) => ({
    ...state,
    fetchAuthenticateUserRequestId: action.payload,
  }),

  [acceptTermsAndConditions]: (state, action) => ({
    ...state,
    fetchAcceptTermsAndConditionsId: action.payload,
  }),

  [setCurrentLoginAddress]: (state, action) => ({
    ...state,
    currentLoginAddress: action.payload,
  }),

});


export default loginReducer;
